import React from 'react';
import Logo from '@assets/images/logo.png';
import { Col, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import Style from './SuccessPage.module.scss';

const successPage = props => {
  return (
    <div className={'d-flex align-items-center ' + Style.container}>
      <div className={'d-flex align-items-center w-100'}>
        <div className={'w-100'}>
          <img src={Logo} className={'mx-auto d-block'} alt={'Company Logo'} style={{width: '200px'}} />

          <div className={'text-center font-weight-bold font-xl mb-2 mt-3'}>
            Check Your Email
          </div>
          <p className={'text-center'}>
            We’ve emailed you instructions to reset your password.
          </p>
          <p className={'text-center '}>
            If you do not receive this email within a few minutes, please check
            your junk/spam folder.
          </p>
          <Row className={'pb-2'}>
            <Col xs={10} className={'mx-auto text-center'}>
              <hr />
              <div>
                Already have an account? <Link to={'/'}>Login</Link>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default successPage;
